import { CashOnDeliveriesRepository } from '../repositories/cash_on_deliveries.repository'
import {
    CashOnDeliveriesExcelParams,
    CashOnDeliveriesExcelResponse,
    CashOnDeliveriesParams,
    CashOnDeliveriesResponse,
    UpdateCashOnDeliveriesPayload,
} from '../types/cash_on_deliveries.types'

const ordersRepository = new CashOnDeliveriesRepository()

export class CashOnDeliveriesService {
    async getList(params: CashOnDeliveriesParams): Promise<CashOnDeliveriesResponse> {
        const response = await ordersRepository.getList(params)
        return response.data
    }

    async exportExcel(params: CashOnDeliveriesExcelParams): Promise<CashOnDeliveriesExcelResponse> {
        const response = await ordersRepository.exportExcel(params)
        return response.data
    }

    async updateCashOnDeliveries(params: UpdateCashOnDeliveriesPayload): Promise<void> {
        const response = await ordersRepository.updateCashOnDeliveries(params)
        return response.data
    }
}
